var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_12_22037)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_22037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54666 29.8667L12.804 13.552H18.504L24.7867 29.8667H19.112L17.8453 26.624H13.4627L12.2213 29.8667H6.54666ZM14.1213 22.824H17.1867L15.6413 18.872L14.1213 22.824Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4207 30.12C34.6607 30.12 34.0021 30.0271 33.4447 29.8413C32.8874 29.6387 32.3723 29.36 31.8994 29.0053L31.6461 29.8667H26.9341V12.792H32.3807V18.188C32.7354 18.0022 33.1745 17.8587 33.6981 17.7573C34.2216 17.656 34.7283 17.6053 35.2181 17.6053C37.0421 17.6053 38.4691 18.0782 39.4994 19.024C40.5296 19.9698 41.0447 21.5489 41.0447 23.7613C41.0447 25.9062 40.5296 27.5022 39.4994 28.5493C38.4861 29.5965 37.1265 30.12 35.4207 30.12ZM33.8501 26.2187C34.3905 26.2187 34.7958 26.0413 35.0661 25.6867C35.3531 25.332 35.4967 24.7155 35.4967 23.8373C35.4967 22.9591 35.3531 22.3595 35.0661 22.0387C34.7958 21.7009 34.3905 21.532 33.8501 21.532C33.2589 21.532 32.7691 21.7009 32.3807 22.0387V25.6613C32.5834 25.8302 32.8029 25.9653 33.0394 26.0667C33.2758 26.168 33.5461 26.2187 33.8501 26.2187Z",
    fill: "#E26D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7747 9.11867H3.532V34.4013H25.7747V9.11867Z",
    stroke: "#E26D5C",
    strokeWidth: 2.1,
    strokeDasharray: "2 2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_12_22037",
    x: 0,
    y: 0,
    width: 45.0133,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12_22037"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_12_22037",
    result: "effect2_dropShadow_12_22037"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12_22037",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_22037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.0133,
    height: 38,
    fill: "white",
    transform: "translate(3 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo-mobile.8c5ca92634fd6c81030d346c012cac1b.svg";
export { ForwardRef as ReactComponent };